import Columns from '@/classes/templates/Columns'

export default class Row {
  constructor ({ columns } = {}) {
    this.columns = new Columns(columns)
  }
}